import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { createRouter, createWebHistory } from 'vue-router'
import App from './App.vue'
import Home from './views/Home.vue'
import About from './views/About.vue'
import Dashboard from './views/Dashboard.vue'
import Media from './views/MediaClean.vue'
import Prompting from './views/Prompting.vue'

// Import styles
import './assets/styles/main.css'

// Create router
const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
      meta: {
        title: 'Home - Vue 3 + Vite App'
      }
    },
    {
      path: '/about',
      name: 'About',
      component: About,
      meta: {
        title: 'About - Vue 3 + Vite App'
      }
    },
    {
      path: '/dashboard',
      name: 'Dashboard',
      component: Dashboard,
      meta: {
        title: 'Dashboard - Vue 3 + Vite App'
      }
    },
    {
      path: '/media',
      name: 'Media',
      component: Media,
      meta: {
        title: 'Media Upload - Vue 3 + Vite App'
      }
    },
    {
      path: '/prompting',
      name: 'Prompting',
      component: Prompting,
      meta: {
        title: 'AI Prompting - Vue 3 + Vite App'
      }
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { top: 0 }
    }
  }
})

// Router navigation guard for page titles
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})

// Create pinia store
const pinia = createPinia()

// Create app
const app = createApp(App)

// Use plugins
app.use(pinia)
app.use(router)

// Mount app
app.mount('#app')
